import script from "./ViewingCardTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewingCardTitle.vue?vue&type=script&setup=true&lang=ts"

import "./ViewingCardTitle.vue?vue&type=style&index=0&id=b4564250&lang=postcss"

const __exports__ = script;

export default __exports__